import json from '../assets/vcClass.json';
import { apiEndPoint } from '../config';
import { http } from './httpService';
const { url } = apiEndPoint;

// Dashboard API's

export function getAssigned(jsonData) {
    return http.post(url + "/toll/user/assigned", jsonData);
}

export function getAllViolationData(jsonData) {
    return http.post(url + "/toll/violation/status", jsonData ).catch(function (error) {
        return {}
    })
}

export function getLowerFareCountAmt(jsonData) {
    return http.post(url + "/LowerFare/countAmt", jsonData);
  }

export function getAllViolationUnassignData(jsonData) {
    return http.post(url + "/toll/violation/unassigned", jsonData);
}

export function getAllViolationUnassignDataBankSide(jsonData) {
    return http.post(url + "/toll/violation/banksidependding", jsonData);
}

export function getAllViolationForOthers(jsonData) {
    return http.post(url + "/toll/user/otherusers", jsonData);
}

export function getAllAssignToOtherVioDetail(jsonData) {
    return http.post(url + "/toll/violation/otherplazausercount", jsonData);
}

export function getViolationStatus(jsonData) {
    return http.post(url + "/toll/violation/remarks", jsonData)
}

export function assignmentPopupData(...jsonData) {
    return http.put(url + "/toll/violation/assign", jsonData[1], { headers: jsonData[0] }).catch(function (error) {
        return {}
    })
}

export function unAssignmentPopupData(jsonData) {
    return http.put(url + "/toll/violation/unassign", jsonData).catch(function (error) {
        return {}
    })
}

// Plaza Dropdown Api

export function getPlaza(requestBody) {
    // Check if 'plaza' is an array and convert it to a comma-separated string
    if (Array.isArray(requestBody.plaza)) {
        requestBody.plaza = requestBody.plaza.join(",");
    }
    return http.post(url + "/toll/violation/getplaza", requestBody)
        .catch(function (error) {
            console.error("Error fetching plaza data:", error);
            return {};
        });
}

//  Assigned Violation Screen API's5

export function getGridDataForPendingForReviewListing(...jsonData) {
    return http.post(url + "/toll/violation/status/review/list", jsonData[1], { headers: jsonData[0], params: jsonData[2]});
}

export function getGridDataForAssigntome(...jsonData) {
    return http.post(url + "/toll/user/assigned/list", jsonData[1], { headers: jsonData[0], params: jsonData[2]});
}

export function getGridDataForPendingForReviewCompleteListing(...jsonData) {
    return http.post(url + "/toll/violation/status/Complete/list", jsonData[1], { headers: jsonData[0], params: jsonData[2]});
}

export function sumitCases(...jsonData) {
    if(jsonData[2] === "Image Not Found") {
        return http.put(url + "/toll/violation/tollSubmit", jsonData[1], { headers: jsonData[0]});
    } else {
        return http.put(url + "/toll/violation/tollSubmitOthers", jsonData[1], { headers: jsonData[0]});
    }
}

export function sumitCasesAgre(...jsonData) {
    return http.put(url + "/toll/violation/tollagree", jsonData[1], { headers: jsonData[0]});
}

export function s3Upload(files) {
    return http.post(url + "/toll/violation/s3ImageUpload", files);
}

export function downloadAssignedViolation(...jsonData) {
    return http.post(url + "/toll/violation/status/complete/list/download", jsonData[1], { headers: jsonData[0], responseType: "blob" });
}

export function downloadReviewViolation(...jsonData) {
    return http.post(url + "/toll/violation/status/review/list/download", jsonData[1], { headers: jsonData[0] });
}

//  Search Api
export function getGridSearchData(searchtext,searchType, jsonData) {
    const params = new URLSearchParams({
        search_key: searchtext,
        search_type: searchType,
      }).toString();
      return http.post(`${url}/toll/violation/search?${params}`, jsonData);
}

// Comment API
export function getComments(id) {
    return http.get(url + "/toll/comment/rrn?CaseId=" + id).catch(function (error) {
        return {}
    });
}

export function savecomment(jsonData) {
    return http.post(url + "/toll/comment/save", jsonData).catch(function (error) {
        return {}
    })
}


// Upload File / Image API
export function uploadFilesAndImagesAPI(formdata){
    return http.post( url + "/toll/violation/bulkuploadImageXLS",formdata);
}


// AuditLog Popup Grid Data
export function getAuditGridData(caseId) {
    return http.get(url + "/toll/violation/audit?caseId=" + caseId);
}

// Login Api 
export function signin(jsonData) {
    return http.post(url + "/auth/signin", jsonData);
}


// Logout Api
export function signout() {
    return http.put(url + "/auth/logout");
}

export function getVCClassChartData(){
    return json;
}

// Violation Analysis Api's
export function getDayWiseData(jsonData){
    return http.post(url +"/toll/violation/daily_trends",jsonData)
}

export function getWeekWiseData(jsonData) {
    return http.post(url + "/toll/violation/weekly_trends", jsonData)
}

export function getMonthWiseData(jsonData) {
    return http.post(url + "/toll/violation/monthly_trends", jsonData)
}

export function getPlazaTrandChartData(jsonData){

    return http.post(url +"/toll/violation/plaza_trends", jsonData);
}

export function getRepeatedViolationsChartData(jsonData){
    return http.post(url +"/toll/violation/duplicate_tags", jsonData);
}

export function getNPCI_VCTrand(jsonData){
    return http.post(url +"/toll/violation/npci_vc_trends", jsonData)
}

export function getMapped_AVC_Trand(jsonData,npciVc){
    return http.post(url +"/toll/violation/mapped_avc_trends?npciVc="+npciVc,jsonData);
}

// Manual Violation Api
export function submitNewViolation(headerJson,formData) {
    return http.post(url + "/toll/violation/submit/newViolation", formData, { headers: headerJson});
}

//New Login
export function newlogin(bodyJson) {
    return http.post(url + "/sso/validate", bodyJson);
}

// --------------------------- Concessionaire Dashboard Api's -----------------------------------------------------

// API for Transaction's block's
export function getTransactionData(jsonData){
    return http.post(url +"/toll/concessionaire/dashboard/transaction/count", jsonData);
  }
  
  // Api for Transaction date wise 1st block
  export function getTransactionDateWiseData(jsonData){
    return http.post(url +"/toll/concessionaire/dashboard/transaction/count/behaviour", jsonData);
  }
  
  // Api for Transaction date wise 2nd block
  export function getTransactionAmountDateWiseData(jsonData){
    return http.post(url +"/toll/concessionaire/dashboard/transaction/sum/behaviour",jsonData);
  }
  
  // API for Transaction Amount Block
  export function getTransactionAmountData(jsonData){
   return http.post(url +"/toll/concessionaire/dashboard/transaction/sum", jsonData);
  }
  
  // Api for chart 
  export function getConsessionerChartData(jsonData) {
    return http.post(url +"/toll/concessionaire/dashboard/vc/count", jsonData);
  }
  
  // Api for dataTable list
export function getTransactionResponseData(jsonData) {
    return http.post(url + "/toll/concessionaire/dashboard/transaction/response/count", jsonData);
  }
  
  export function getTransactionExceptionResponseData(jsonData) {
    return http.post(url + "/toll/concessionaire/dashboard/exception/count", jsonData);
  }
  // API for rejection for reason
  export function getRejectionByReasoneData(jsonData) {
    return http.post(url + "/toll/concessionaire/dashboard/rejection/reason", jsonData);
  }
  
  // Api for 4th row Line chart (TransactionTrendByStatus)
  export function getTransactionTrendByStatusData(plaza){
    return http.post(url +"/toll/concessionaire/dashboard/transaction/status",{plazaIds:plaza});
  }
  
  // Api for 4th row 2nd Line chart (TransactionVsViolations)
  export function getTransactionVsViolationsData(plaza){
    return http.post(url +"/toll/concessionaire/dashboard/transaction/monthly/status",{plazaIds:plaza});
  }
  
  // Api for 5th row TransactionTrendByTimeSLot
  export function getTransactionTrendByTimeSlotData(jsonData){
    return http.post(url +"/toll/concessionaire/dashboard/transaction/trend/time",jsonData);
  }
  
  // Api for 5th row TransactionTrendByTimeSLot
  export function getViolationPendingDueData(plaza){
    return http.post(url +"/toll/concessionaire/dashboard/violation/pending",{plazaIds:plaza});
  }
  
  // Api for all Plaza User
  export function getPlazaUsers() {
    return http.get(url + "/toll/concessionaire/dashboard/users");
  }
  
  // Api for get User wise plaza
  export function getUserWisePlaza(paramsJson) {
    return http.get(url + "/toll/concessionaire/dashboard/users/plaza", { params: paramsJson });
  }

  // Api for Plaza tat
  export function getPlazaTAT(){
      return http.get(url +"/toll/violation/tat",{headers:{"name":"plaza_tat"}});
  }
  
  // Api for INIT File 2nd row
  export function getINITFileData(jsonData) {
    return http.post(url + "/toll/concessionaire/dashboard/init", jsonData)
  }

  // Api for Cash Manual Transaction Data
  export function getCashManualTransactionData(jsonData) {
    return http.post(url + "/toll/concessionaire/dashboard/cashmanual", jsonData)
  }
  
  // Api for ACk or NACK Files 2nd row
   export function getAckNackFilesData(jsonData) {
    return http.post(url + "/toll/concessionaire/dashboard/ack", jsonData)
   }
  
   // Api for ChargeBack Pending or Due Data
   export function fetchChargeBackPendingDueData(jsonData){
    return http.post(url +"/toll/concessionaire/dashboard/chargeback", jsonData);
  }
  
   // Api for Last 3 Toll Files
   export function getLastThreeTollFiles(jsonData){
    return http.post(url + "/toll/concessionaire/dashboard/tollFiles", jsonData);
   }
  
  
   // Api for Last BTL Files
   export function getLastThreeBTLFiles(jsonData){
    return http.post(url + "/toll/concessionaire/dashboard/btlFiles", jsonData);
   }
  
   // Api for Last Discount Files
   export function getLastThreeDiscountFiles(jsonData){
    return http.post(url + "/toll/concessionaire/dashboard/disFiles", jsonData);
   }
  
   // API for Lane wise transaction trend chart
   export function getLaneWiseTransactionData(jsonData) {
    return http.post(url + "/toll/concessionaire/dashboard/lane", jsonData);
  }

  // Api for Phase-5

// API for Lane wise transaction trend chart
export function getPieChartDataAPI(headerJson) {
    return http.post(url + "/toll/concessionaire/dashboard/entry/point", headerJson);
  }
  
  // API for Lane wise transaction trend chart
  export function getBarChartDataAPI(headerJson) {
    return http.post(url + "/toll/concessionaire/dashboard/entry/avc", headerJson);
  }


//---------- API for Raised New Violation Screen
export function getImpactedTransactionData(headerJson,requestBody,impactedTransaction){
    if(impactedTransaction === 'raiseNewViolation')
        return  http.post(url +"/toll/manual/search", requestBody, {headers:headerJson})
    else if(impactedTransaction === 'eligibleForDA')
        return  http.post(url +"/toll/manual/search-eligibleDA", requestBody, {headers:headerJson})
    else
        return  http.post(url +"/toll/manual/ca/search", requestBody, {headers:headerJson})
}

export function submitDisputeDetails(headerJson,formData,impactedTransaction){
    if(impactedTransaction === 'raiseNewViolation')
        return http.post(url +"/toll/manual/submit", formData,{headers: headerJson})
    else if(impactedTransaction === 'eligibleForDA')
        return http.post(url +"/toll/manual/submit-eligibleDA", formData,{headers: headerJson})
    else
    return http.post(url +"/toll/manual/ca/submit", formData,{headers: headerJson})
}

export function getClaimedAvcDropDownData(jsonData){
    return http.post(url +"/toll/manual/concess", jsonData)
}

export function getAllViolationReason(plaza){
    const paramsJson = {
        plazaId: plaza,
      };
  return http.get(url + "/toll/violation/reasondropdown", {
      params: paramsJson,
    });
}

export function getClaimedAvcFareAmount(headerJson, bodyJson){
    return http.post(url +"/toll/manual/fareamount", bodyJson, {headers: headerJson})
}

export function validateViolationForRaisedDispute(headerJson,impactedTransaction){
    if(impactedTransaction === 'raiseNewViolation')
    return http.get(url +"/toll/manual/check", {headers: headerJson})
    else
    return http.get(url +"/toll/manual/ca/check", {headers: headerJson})
}

// Get Listing Data for Raised Credit Adjustment 
export function getAllRaisedCAData(headerJson,bodyJson,paramJson){
    return  http.post(url +"/toll/manual/ca/list", bodyJson, {headers: headerJson, params:paramJson})
}

export function getAllRaisedCADataDownload(headerJson,bodyJson){
    return  http.post(url +"/toll/manual/ca/download", bodyJson, {headers: headerJson, responseType: 'arraybuffer'})
}

// API for Txr vs violation vs chargeback bar chart for seleced period
export function getTxnvsViovsChrgbkBarChartDataAPI(headerJson) {
    return http.post(url + "/toll/concessionaire/dashboard/transaction/order", headerJson)
  }

//ETC TAT SLA Report
export function getPlazaDropdown(jsonBody){
    return http.post(url +"/toll/ETCReport/getplaza", jsonBody)
}

export function ETCReport(jsonBody) {
    return http.post(url + "/toll/ETCReport/downloadReport", jsonBody, {
      responseType: "blob",
    });
  }

  export function getETCConfig() {
    return http.get(url + "/toll/ETCReport/getConfig").catch((error) => {
      console.error("Error fetching config:", error);
      return { data: {} };
    });
  }


  export function getPlazaNameType(plazaid) {
    return http
      .get(url + "/toll/violation/getPlazaNameType?plazaId=" + plazaid)
      .catch(function (error) {
        return {};
      });
  }

  export function getGazettePath(gazetteId) {
    return http.get(
      url + "violation/gazette/gazettePath/" + gazetteId
    );
  }

  export function getGazette(gazettePath) {
    return http.get(url + `violation/gazette-download`, {
      params: { key: gazettePath }
    });
  }